import { memo, type ReactNode } from 'react'

import { Stack, Text } from '@mantine/core'

export const LegalRestrictionContainer = memo<{ children: ReactNode }>(
  function LegalRestrictionContainer({ children }) {
    return (
      <Stack gap="xs">
        <Text opacity={0.7}>
          Fission&apos;s real world asset tokens have legal restrictions
        </Text>
        {children}
      </Stack>
    )
  },
)
